import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { MailingTypeEnum } from '@zaoblako/shared/modules/notification/enums/mailing.type.enum';

/**
 * Localized human-readable string representations of
 * {@link MailingTypeEnum} enumeration values
 */
export const MailingTypeEnumI18n: Record<I18nLocalesEnum, Record<MailingTypeEnum, string>> = {
  [I18nLocalesEnum.RU_RU]: {
    [MailingTypeEnum.DEBTORS]: 'Должники из 1С',
    [MailingTypeEnum.DEBTORS_FROM_FILE]: 'Должники из Excel-файла',
    [MailingTypeEnum.BILLS]: 'Счета',
    [MailingTypeEnum.COMMON]: 'Информация',
    [MailingTypeEnum.HELPDESK]: 'HelpDesk',
    [MailingTypeEnum.DOCUMENTS]: 'Документы',
  },
  [I18nLocalesEnum.EN_US]: {
    [MailingTypeEnum.DEBTORS]: 'Debtors from 1C ERP',
    [MailingTypeEnum.DEBTORS_FROM_FILE]: 'Debtors from Excel file',
    [MailingTypeEnum.BILLS]: 'Bills',
    [MailingTypeEnum.COMMON]: 'Common mailings',
    [MailingTypeEnum.HELPDESK]: 'HelpDesk',
    [MailingTypeEnum.DOCUMENTS]: 'Documents',
  },
};
